import type { ReactNode } from 'react';

import {
  DC_Domain_Models_Products_CostDetailType,
  DC_Domain_Models_Products_DiscountType,
  DC_Domain_Models_Products_ProductType,
  Products_Offers_ContractSpan,
  Products_Offers_Usages,
  Products_VatModel,
} from '@monorepo-types/dc';

import type { FlowContext } from './machine';

export interface Price {
  value: string | number;
  previousValue?: string | number;

  period?: string;
  type?: DC_Domain_Models_Products_CostDetailType;
}

export enum ProductTypes {
  SOLARPANELS = 'solarPanels',
  HEATPUMP = 'heatPump',
  CENTRALHEATING = 'centralHeating',
}

export interface CostDetails {
  usages?: Products_Offers_Usages;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface Product {
  type: DC_Domain_Models_Products_ProductType;

  title?: string;
  tag?: string;

  code: string; // SKU
  productCombinationCode?: string;

  variant?: DC_Domain_Models_Products_DiscountType;

  contractSpan?: Products_Offers_ContractSpan;

  costsMonthly?: Products_VatModel;
  costsYearly?: Products_VatModel;

  costDetails: Record<string, unknown>;

  contractEndDate?: string;
  contractStartDate?: string;

  mostPopularChoice?: boolean;
}

export interface OfferContractSpan extends Products_Offers_ContractSpan {
  type: DC_Domain_Models_Products_ProductType;
}

export interface Offer {
  type: DC_Domain_Models_Products_DiscountType;

  title?: string;
  tag?: string;

  usps?: string[];

  products: Product[];

  mostPopularChoice: boolean;

  costsMonthly?: Products_VatModel;
  costsYearly?: Products_VatModel;
  costsYearlyPromotion?: Products_VatModel;

  costDiscounts: {
    cashback?: Price;
  };

  costDetails: CostDetails;

  contractSpan?: OfferContractSpan[];

  contractEndDate?: string;
  contractStartDate?: string;
}

export interface OfferTermsAndConditions {
  title: string;
  href: string;
}

export interface Dialog {
  trigger: string;

  title: string;
  content?: string | ReactNode;
}

export type DetailsIconType =
  | 'profile'
  | 'situation'
  | 'address'
  | 'contact'
  | 'gas'
  | 'water'
  | 'electricity'
  | 'heating'
  | 'toon'
  | 'calendar'
  | 'company'
  | 'boiler'
  | 'envelope'
  | 'orderPackage'
  | 'other';

export interface NotificationField {
  editable?: string;
  value: {
    content: string;
    title: string;
    variant?: 'info' | 'success' | 'warning' | 'error' | 'chat';
  };
}

export interface TextField {
  editable?: string;
  value: string;
}

export interface Content {
  text: TextField;
  title: TextField;
  notification: NotificationField;
}

export interface Fields {
  content: Content;
}

export interface EnecoInHuisFlowContext extends FlowContext {
  SuppliedPhone?: string;
  SuppliedEmail?: string;
  salutation?: string;
  kopenOfHuren?: string;
  firstName?: string;
  surnamePreposition?: string;
  surname?: string;
  phoneNumber?: string;
  emailAddress?: string;
  C1?: boolean;
}
